import React, { useContext } from "react";
import {
  SpreadsheetContext,
  CellError,
} from "@gistapps/composite-spreadsheet";
import type {
  DataViewerProps,
} from "@gistapps/composite-spreadsheet";

const DefaultCellViewer = ({ cell, row, column }: DataViewerProps) => {

  const {
    errors,
    translations,
  } = useContext(SpreadsheetContext);

  const hasError = !!errors?.[row]?.[column];
  const errorMessage = translations?.error_invalid_value || "Please enter a valid value";
  const value = cell?.value?.toString() ?? "";

  return (
    <div className={`Spreadsheet__data-viewer rss__data-viewer${hasError ? " rss__data-viewer--error" : ""}`}>
      <span className="rss__cell-value">
        {value}
      </span>
      {hasError ? <CellError message={errorMessage} /> : null}
    </div>
  );

};

export default DefaultCellViewer;
